import { CommonPagingResponse, OrderHistoryType } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _OrderHistoryService {
  public getOrderHistory(order_id: string, page: number) {
    return HttpService.get<CommonPagingResponse<OrderHistoryType>>(
      `/order-history/${order_id}?page=${page}`
    );
  }
}

const OrderHistoryService = new _OrderHistoryService();

export default OrderHistoryService;
